require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-automechanika-at-the-birmingham-nec.json") })
        }
      }, "path---news-automechanika-at-the-birmingham-nec");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-automechanika-at-the-birmingham-nec!./.cache/json/news-automechanika-at-the-birmingham-nec.json
// module id = 1417
// module chunks = 231608221292675